module.exports = __webpack_public_path__ + "media/application/images/ui/member-icon-154677cb3ac606f817e9efb2881d93cb.png";